import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ApiStudyDto } from 'kes-common';

import { studyDelete } from '../../api';

const useTemplateDelete = (templateId: ApiStudyDto['id'], options?: UseMutationOptions) =>
	useMutation(() => studyDelete(templateId).then((response) => response.expectSuccess()), options);

export default useTemplateDelete;
